import $ from "jquery";
import axios from "axios";

const formClass = 'topic-async-attachment-upload-form';
const hidden = 'contest__hidden';
const fileIdField = "forumtopicform-file_id_list";

export const forumTopicAttachmentUpload = () => {
    let currentInput = undefined;

    readFiles('topic-file');

    handleFileRemove();

    $('.topic-async-attachment-upload-file').on('change', function () {
        currentInput = $(this);
    });

    window.$(document).on('afterValidateAttribute', `.${formClass}`, async function (event, attribute, messages) {
        if (currentInput === undefined || !currentInput.val() || attribute.id !== currentInput.attr('id')) {
            return;
        }

        await sendFile(currentInput);

        currentInput.val(undefined);
    });
};

const handleFileRemove = () => {
    $('.uploaded-file__delete-file-icon').on('click', function () {
        const idForRemove = $(this).data('id');
        const elementForRemove = $(this).parents('.new-topic__uploaded-file');

        axios.post('/rest/forum/upload/remove-topic-file', [],{params: {id: idForRemove}})
            .then((response) => {
                removeFileFromMainFormInput(idForRemove);
                elementForRemove.remove();
            });
    });
};

const findCommonElements = (input) => {
    const fileWidget = input.parents('#topic-file');

    return {
        fileWidget: fileWidget,
        fileInputWrapper: fileWidget.find('.new-topic__file'),
        fileIndicator: fileWidget.find('.contest-work__preloader'),
    }
}

const readFiles = function (name) {
    const dropzone = document.getElementById(name);

    if (dropzone === null || dropzone === undefined) {
        return;
    }

    const input = $(`.topic-async-attachment-upload-file`);

    dropzone.ondragover = function (e) {
        e.preventDefault();
        this.classList.add('dragover');
    };
    dropzone.ondragleave = function (e) {
        e.preventDefault();
        this.classList.remove('dragover');
    };
    dropzone.ondrop = function (e) {
        e.preventDefault();
        this.classList.remove('dragover');
        input[0].files = e.dataTransfer.files;

        sendFile(input);
    }
};

const sendFile = (currentInput) => {
    if (currentInput === undefined || !currentInput.val()) {
        return;
    }

    const input = currentInput;
    const elements = findElements(input);
    const errorText = elements.errorTextBox.text();

    currentInput = undefined;

    if (errorText) {
        elements.errorTextBox.text('');

        alert(errorText);

        input.val(null);

        return;
    }

    elements.fileInputWrapper.addClass(hidden);

    elements.fileIndicator.removeClass(hidden);

    setProgress(elements.fileIndicator, 0);

    let formData = new FormData(elements.form[0]);

    return $.ajax({
        url: input.attr('data-url'),
        async: true,
        type: 'POST',
        data: formData,
        dataType: 'json',
        processData: false,
        contentType: false,
        xhr: function () {
            let myXhr = $.ajaxSettings.xhr();

            if (elements.fileIndicator.length === 0) {
                return myXhr;
            }

            if (myXhr.upload) {
                myXhr.upload.addEventListener('progress', function (e) {
                    const percent = Math.floor(100 * e.loaded / e.total);

                    setProgress(elements.fileIndicator, percent);
                }, false);
            }

            return myXhr;
        },
        error: function (data) {
            const messageJson = data.responseJSON && data.responseJSON.message;
            let messageString = '';

            try {
                const messageObject = messageJson && JSON.parse(messageJson);
                messageString = messageObject && messageObject.file;
            } catch (e) {
                messageString = messageJson;
            }

            if (!messageString) {
                messageString = 'Upload error. Try other file.';
            }

            removeAttachment(input, elements);

            alert(messageString);

            input.val(null);
        },
        success: function (json) {
            if (!json || !json.data) {
                return;
            }

            const fileData = json.data;

            $('.new-topic__uploaded-files').append(
                newFileTemplate(fileData)
            );

            handleFileRemove();
            addFileToMainFormInput(fileData.id);

            if (fileData.name) {
                elements.fileIndicator.addClass(hidden);
                elements.fileInputWrapper.removeClass(hidden);
            }

            currentInput = undefined;
        }
    })
}

const addFileToMainFormInput = (fileId) => {
    const filesInput = document.getElementById(fileIdField);

    let idList = filesInput.value !== undefined && filesInput.value.length > 0 ?
        JSON.parse(filesInput.value) :
        [];
    idList.push(fileId);

    filesInput.value = JSON.stringify(Array.from(new Set(idList)));
}

const removeFileFromMainFormInput = (fileId) => {
    const filesInput = document.getElementById(fileIdField);

    let idList = filesInput.value !== undefined && filesInput.value.length > 0 ?
        JSON.parse(filesInput.value) :
        [];
    idList = idList.filter(id => id === fileId);

    filesInput.value = JSON.stringify(idList);
}

const newFileTemplate = (fileData) => {
    return `
        <div class="new-topic__uploaded-file">
            <div class="uploaded-file">
                <i class="uploaded-file__icon"></i>
                <span title="${fileData.name}">${fileData.cutName}</span>
                <i class="uploaded-file__delete-file-icon" data-id=${fileData.id}></i>
            </div>
        </div>    
    `;
};

const findElements = (input) => {
    const elements = findCommonElements(input);

    elements.form = input.parents(`.${formClass}`);
    elements.errorTextBox = elements.form.find('.help-block-error');
    elements.displayText = elements.fileWidget.find(
        '.new-topic__uploaded-files'
    );

    return elements;
}

const setProgress = (indicator, percents) => {
    const circle = indicator.find('.contest-work__preloader-svg-bar');
    const radius = circle.attr('r');
    const pct = ((100 - percents) / 100) * (Math.PI * radius * 2);

    circle.css({strokeDashoffset: pct});
    indicator.attr('data-pct', percents);
}

const removeAttachment = function (input, elements) {
    input.val(null);

    setIdValue(input, null);

    elements.fileWidget.removeClass(hidden);
    elements.fileInputWrapper.removeClass(hidden);
    elements.fileIndicator.addClass(hidden);
};

const setIdValue = (input, value) => {
    $(`[name="${input.attr('data-input-name')}"]`).val(value);
}
